import { Avatar, Stack, Typography } from '@common/components'
import { handleGravatar } from '@common/utils/gravatar'
import { useUser } from '@features/auth/hooks'
import { Paper, SessionPaper, SessionsWrapper } from './sidebar-dashboard.styles'
import { isUNSW } from '../../../utils/unswUtils'
import DisplaySessions from '@features/booking/display-sessions'
import { useLocation } from '@lib/router'
import ResourcesTopicsView from '@features/workshops/components/resources-topics-view'

const SidebarDashboard = (props: any) => {
  const { user } = useUser()
  const { pathname } = useLocation()
  return (
    <Stack sx={{ height: 'calc(100vh - 150px)' }} {...props}>
      <Stack
        spacing={2}
        sx={{ mb: 2, display: { xs: 'none', md: 'flex' }, flexDirection: 'column' }}
      >
        <Paper sx={{ height: '80px', display: 'flex', justifyContent: 'flex-start' }}>
          <Avatar src={handleGravatar(user?.image ?? '')} />
          <Stack>
            <Typography sx={{ ml: 1 }}>
              Welcome back{' '}
              <span style={{ fontWeight: 600 }}>{user?.full_name ?? user?.username}</span>
            </Typography>
          </Stack>
        </Paper>
        {/* {!isUNSW() ? <NextSessionTime /> : <DisplayClassroom />} */}
      </Stack>
      <SessionsWrapper>
        <SessionPaper sx={{ flex: 1 }}>
          {pathname.includes('resources') ? <ResourcesTopicsView /> : <DisplaySessions />}
        </SessionPaper>
      </SessionsWrapper>
    </Stack>
  )
}

export default SidebarDashboard
